// extracted by mini-css-extract-plugin
export default {"description":"ThankYou_description__Bbgi0"};